import React from "react";
import ProcurementView from "./ProcurementView";

// Overall — the landing page (/v2/inventory/procurement) and the ONLY actionable view of
// the three (see ProcurementView.jsx for why New/Reorder are read-only).
function ProcurementOverallPage() {
    return <ProcurementView view="overall" />;
}

export default ProcurementOverallPage;
